import * as type from './types';

export function logout(data) {
    return {
        type: type.POST_LOGOUT_REQUESTED,
        data: data,
    }
}